import React from 'react';
import DeviceIconSVG from '../DeviceIconSVG';
import { DeviceIconSVGType } from '../models';

const Tablet: DeviceIconSVGType = ({ accentColor }) => (
  <DeviceIconSVG width="48" height="68" viewBox="0 0 48 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="black"
      d="M43.9318 0.757813H4.62328C3.63152 0.760626 2.68117 1.16142 1.97988 1.87262C1.2786 2.58383 0.883389 3.54762 0.880615 4.55341V63.3851C0.883389 64.3909 1.2786 65.3547 1.97988 66.0659C2.68117 66.7771 3.63152 67.1779 4.62328 67.1807H43.9318C44.9245 67.1779 45.876 66.7775 46.5789 66.0666C47.2819 65.3556 47.6794 64.3919 47.6849 63.3851V4.55341C47.6822 3.54577 47.2855 2.58037 46.582 1.86887C45.8784 1.15736 44.9254 0.757809 43.9318 0.757813ZM45.6139 63.3851C45.6084 63.8358 45.4294 64.2665 45.1152 64.5852C44.8009 64.904 44.3762 65.0855 43.9318 65.091H4.62328C4.17801 65.0882 3.75176 64.9076 3.43691 64.5883C3.12205 64.2689 2.94394 63.8367 2.94118 63.3851V4.55341C2.94394 4.10184 3.12205 3.66956 3.43691 3.35025C3.75176 3.03094 4.17801 2.85032 4.62328 2.84752H43.9318C44.3762 2.85305 44.8009 3.03455 45.1152 3.35328C45.4294 3.672 45.6084 4.1027 45.6139 4.55341V63.3851Z"
    />
    <path fill="black" d="M5.5393 57.2422H5.27539V57.5098H5.5393V57.2422Z" />
    <path fill="black" d="M5.5393 57.2422H5.27539V57.5098H5.5393V57.2422Z" />
    <path
      fill="black"
      d="M5.20215 6.91895V56.7095H43.3542V6.91895H5.20215ZM7.15759 8.89137H41.4093V54.737H7.15759V8.89137ZM5.45446 56.4536V56.1977H5.73832V56.4536H5.45446Z"
    />
    <path
      fill="black"
      d="M26.6393 61.5308C26.6414 62.0062 26.5042 62.4715 26.2451 62.8676C25.9859 63.2637 25.6166 63.5728 25.184 63.7557C24.7513 63.9386 24.2748 63.987 23.815 63.8948C23.3552 63.8026 22.9327 63.5739 22.6013 63.2378C22.2698 62.9016 22.0443 62.4732 21.9534 62.0069C21.8625 61.5405 21.9102 61.0573 22.0905 60.6185C22.2709 60.1798 22.5757 59.8052 22.9663 59.5424C23.3569 59.2797 23.8157 59.1405 24.2844 59.1426C24.5936 59.1426 24.8999 59.2044 25.1856 59.3244C25.4713 59.4444 25.7309 59.6203 25.9496 59.8421C26.1683 60.0639 26.3417 60.3271 26.4601 60.6169C26.5784 60.9067 26.6393 61.2172 26.6393 61.5308Z"
    />
    <path fill={accentColor} d="M25.5711 21.573L12.5138 34.8836L11.0986 33.441L24.1669 20.1416L25.5711 21.573Z" />
    <path fill={accentColor} d="M37.4674 20.8435L12.5138 46.2926L11.0986 44.85L36.0633 19.4121L37.4674 20.8435Z" />
  </DeviceIconSVG>
);

export default Tablet;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/DeviceIcon/icons/Tablet.tsx